export function optionalLocaleFetchOptions(
    localePrefix: string | undefined,
    getLocaleCodeFromPrefix: (prefix: string) => string | undefined,
): {query: {locale: string}} | Record<string, never> {
    const locale = localePrefix ? getLocaleCodeFromPrefix(localePrefix) : undefined;
    return locale ? {query: {locale}} : {};
}
